import React from 'react';
import waterHeroImg from '../assets/water-quality1.jpg';

const stats = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path d="M12 2.5c3.5 4.5 6.5 8.7 6.5 12a6.5 6.5 0 11-13 0c0-3.3 3-7.5 6.5-12z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: '2 Billion People',
    body: 'Lack access to safely managed drinking water worldwide, forcing many to rely on sources contaminated with bacteria and pathogens.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path d="M12 21s-7-4.35-9.5-8.5C.7 9 2 5 6 5c2 0 3.5 1.2 4 2 .5-.8 2-2 4-2 4 0 5.3 4 3.5 7.5C19 16.65 12 21 12 21z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: 'Waterborne Disease',
    body: 'Contaminated water spreads cholera, typhoid and dysentery, causing hundreds of thousands of preventable deaths every year.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
        <path d="M12 3l7 3v5c0 4.5-3 8.5-7 10-4-1.5-7-5.5-7-10V6l7-3z" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: 'Children at Risk',
    body: 'Unsafe water and poor sanitation remain a leading cause of illness and death in children under five worldwide.',
  },
];

export default function WaterQuality() {
  return (
    <section className="pt-28 pb-16 sm:pb-20 bg-gradient-to-b from-teal-50 to-white" data-aos="fade-up">
      <img
        src={waterHeroImg}
        alt="Clean water splash"
        className="w-full h-64 sm:h-80 lg:h-96 object-cover shadow-lg mb-10"
      />

      <div className="max-w-[1600px] mx-auto text-center px-6">
        <h2 className="text-3xl font-bold text-teal-700 mb-4">Why Water Quality Matters</h2>
        <p className="text-gray-600 max-w-2xl mx-auto mb-10">
          Safe drinking water is one of the most basic human needs, yet millions are exposed
          daily to bacteria and contaminants that put their health at risk. Early, reliable
          detection is the first line of defense for families and communities alike.
        </p>

        <div className="grid gap-6 sm:grid-cols-3">
          {stats.map(({ icon, title, body }) => (
            <div
              key={title}
              className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center text-center border border-teal-100"
            >
              <div className="text-teal-600 mb-3">{icon}</div>
              <h3 className="font-semibold text-gray-800 mb-2">{title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>

        </div>
    </section>
  );
}
